let userAgent = navigator.userAgent
if (!/miniProgram/i.test(userAgent)) {
  const url =
    'https://mapapi.qq.com/web/mapComponents/geoLocation/v/geolocation.min.js'
  // 动态设置头js
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = url
  document.head.appendChild(script)
}
